import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState } from 'react';
const Image = ({ errorSrc, loading = 'lazy', ...rest }) => {
    const withError = useRef(false);
    const [currentSource, setCurrentSource] = useState(rest.src);
    const handleError = (event) => {
        if (errorSrc && !withError.current) {
            setCurrentSource(errorSrc);
            withError.current = true;
        }
        rest.onError?.(event);
    };
    return _jsx("img", { ...rest, loading: loading, src: currentSource, onError: handleError });
};
export default Image;
